"use script";

angular.module("core")
.constant("ORDER_STATUS", {
    "TRANSMITTED": "transmitted",
    "INVOICED": "invoiced",
    "MODIFIED": "modified",
    "CANCELLED": "cancelled"
});



//////////////////
// WEBPACK FOOTER
// ./core/order/order.constants.js
// module id = 391
// module chunks = 0